const DEFAULT_EXPLORE_VALUES = {
  enabled: false,
  maxImages: 0,
  imageTagID: '0',
};

interface IPDPExplore {
  enabled: boolean;
  maxImages: number;
  imageTagID: string;
}

export const getMapToState = (remoteConfigPDPExplore: IPDPExplore) => {
  try {
    const { enabled, maxImages, imageTagID } = remoteConfigPDPExplore;

    // if maxImages or imageTagID not present disable the Explore API Call
    if (!maxImages || !imageTagID) {
      // TODO - log error in sentry
      return DEFAULT_EXPLORE_VALUES;
    }

    return {
      enabled: Boolean(enabled),
      maxImages: maxImages,
      imageTagID: imageTagID,
    };
  } catch (e) {
    // TODO - log error in sentry
    return DEFAULT_EXPLORE_VALUES;
  }
};
